import React from 'react'
import classNames from 'classnames'
import { MakeTextComponentProps } from '.'
import { Base } from './Base'

export function makeTextComponent(classes = '', element?: string) {
  return function TextComponent({
    children,
    className,
    ...props
  }: MakeTextComponentProps) {
    return (
      <Base
        className={classNames(classes, className)}
        element={element}
        {...props}
      >
        {children}
      </Base>
    )
  }
}
